import React, {Component} from 'react';
import {Input, InputGroup} from 'reactstrap'
import styles from "./AdminFilters.css";
import DayPickerInput from "react-day-picker/DayPickerInput";

import MomentLocaleUtils, {
    formatDate,
    parseDate,
} from 'react-day-picker/moment';
import moment from 'moment'
import Button from "../Button/Button";
import Headline from "../Headline/Headline";

export default class AdminFilters extends Component {

    constructor(props) {
        super(props);

        this.state = {
            date: new Date()
        }

        this.setFilter = this.setFilter.bind(this);
    }

    setFilter() {
        const {date} = this.state;
        const {filterAction} = this.props;

        filterAction(moment(date).unix() * 1000);
    }

    render() {
        const {date} = this.props;
        return (
            <div className={styles.filterWrapper}>

                <div className={styles.flexWrapper}>

                    <InputGroup className={styles.inputGroup}>
                        <label>Start-Datum:</label>
                        <DayPickerInput
                            className={styles.timePicker}
                            placeholder="Wann?"
                            value={formatDate(date, 'LL', 'de')}
                            onDayChange={day => {
                                this.setState({
                                    date: day.getTime()
                                });
                            }}
                            formatDate={formatDate}
                            parseDate={parseDate}
                            dayPickerProps={{
                                locale: 'de',
                                localeUtils: MomentLocaleUtils,
                            }}
                        />
                    </InputGroup>

                    <Button href={''} onClick={this.setFilter} light pullRight>Anwenden</Button>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AdminFilters/AdminFilters.js